import { render, staticRenderFns } from "./ChatComponent.vue?vue&type=template&id=bc1f6860&scoped=true&"
import script from "./ChatComponent.vue?vue&type=script&lang=ts&"
export * from "./ChatComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ChatComponent.vue?vue&type=style&index=0&id=bc1f6860&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1f6860",
  null
  
)

export default component.exports